export type ClientSource = 'xpm' | 'fyi'

/** Which integration owns a synced client; one both systems know follows the org's current source. Undefined for one added by hand. */
export const clientSource = (client: { xeroId?: string; fyiId?: string } | undefined, orgSource?: ClientSource): ClientSource | undefined => {
   if (orgSource === 'fyi' && client?.fyiId) return 'fyi'
   if (orgSource === 'xpm' && client?.xeroId) return 'xpm'
   if (client?.xeroId) return 'xpm'
   if (client?.fyiId) return 'fyi'
   return undefined
}

export const clientSourceName = (source: ClientSource): string => {
   return source === 'xpm' ? 'XPM' : 'FYI'
}

export const syncedFromLabel = (source: ClientSource): string => {
   return `Synced from ${clientSourceName(source)}`
}
